module.exports = __webpack_public_path__ + "assets/icon-orderType-full.cdcdce3b.svg";